import { render, staticRenderFns } from "./x-errors-messages.vue?vue&type=template&id=4c16f510&scoped=true&"
import script from "./x-errors-messages.vue?vue&type=script&lang=js&"
export * from "./x-errors-messages.vue?vue&type=script&lang=js&"
import style0 from "./x-errors-messages.vue?vue&type=style&index=0&id=4c16f510&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16f510",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c16f510', component.options)
    } else {
      api.reload('4c16f510', component.options)
    }
    module.hot.accept("./x-errors-messages.vue?vue&type=template&id=4c16f510&scoped=true&", function () {
      api.rerender('4c16f510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-errors-messages.vue"
export default component.exports